import React from "react";
import { Box, Typography, Button, Paper } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined"; // 🔒 lock icon
import { useNavigate } from "react-router-dom";

export default function ForbiddenPage() {
    const navigate = useNavigate();

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                p: 2,
            }}
        >
            <Box
                sx={{
                    p: 4,
                    textAlign: "center",
                    borderRadius: 3,
                    maxWidth: 500,
                    width: "100%",
                }}
            >
                {/* Red Lock Icon */}
                <LockOutlinedIcon sx={{ fontSize: 80, color: "error.main", mb: 2 }} />

                <Typography variant="h2" fontWeight="bold" gutterBottom>
                    403
                </Typography>

                <Typography variant="body1" sx={{ mb: 3 }}>
                    Sorry, you don’t have permission to access this page.
                </Typography>

                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => navigate(-1)}
                >
                    Go Back
                </Button>
            </Box>
        </Box>
    );
}
